export default {
  technologies: [],
};
